import { useEffect, useState } from "react";
import ProductsListBgColorNoneP0 from "./ProductsListBgColorNoneP0"
import { PromotionProduct } from "../../api/Promotion";

interface CountdownProps {
    startTime?: string;
    endTime: string; // yyyy-mm-dd hh:mm:ss
    title: string;
    icon?: string;
    products?: PromotionProduct[];
}

export default function CampaignCountdown({ startTime, endTime, title, icon, products }: CountdownProps) {
    const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const target = new Date(endTime).getTime();
        const distance = target - now;

        if (distance <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

        return {
            days: Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((distance / (1000 * 60)) % 60),
            seconds: Math.floor((distance / 1000) % 60),
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    const formatDate = (dateStr: string) => {
        if (!dateStr) return "";
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            const d = String(date.getDate()).padStart(2, "0");
            const m = String(date.getMonth() + 1).padStart(2, "0");
            return `${d}-${m}`;
        } catch (e) {
            return "";
        }
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="styles_wrapperSlider__1UaJZ" id="campaign-9EWLF">
            <div className="styles_wrapperTitle__OSLjq">

                {/* LEFT TITLE */}
                <div className="styles_flexBasis__jC8QR">
                    <div className="MuiBox-root css-0">
                        <div className="MuiGrid-root styles_wrapper_icon_name__zDLid MuiGrid-container">
                            <div className="MuiGrid-root MuiGrid-item">
                                <img
                                    alt="icon mega sale"
                                    src={icon || "https://cdn-web-next.thuocsi.vn/images/deals/mega_sale.svg"}
                                    style={{ width: 32, height: 32, objectFit: 'contain' }}
                                />
                            </div>

                            <div className="MuiGrid-root MuiGrid-item" style={{ flex: "1 1 0%" }}>
                                <p className="MuiTypography-root styles_title__esM0Y MuiTypography-body1">
                                    {title}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT COUNTDOWN */}
                {endTime !== "" && (
                    <div className="styles_flex__vEzd3">
                        <div className="styles_container__cNG6N styles_haveDays__qjdgU">

                            <div className="styles_wrapper_date__QnmfL">
                                <p className="MuiTypography-root styles_date__V1oQF MuiTypography-body1">
                                    {timeLeft.days} ngày
                                </p>
                            </div>

                            <div className="styles_colon__4IHky">:</div>

                            <div className="styles_wrapper_time__t8Si5">
                                <p className="MuiTypography-root styles_time__mnMde MuiTypography-body1">
                                    {String(timeLeft.hours).padStart(2, "0")}
                                </p>
                            </div>

                            <div className="styles_colon__4IHky">:</div>

                            <div className="styles_wrapper_time__t8Si5">
                                <p className="MuiTypography-root styles_time__mnMde MuiTypography-body1">
                                    {String(timeLeft.minutes).padStart(2, "0")}
                                </p>
                            </div>

                            <div className="styles_colon__4IHky">:</div>

                            <div className="styles_wrapper_time__t8Si5">
                                <p className="MuiTypography-root styles_time__mnMde MuiTypography-body1">
                                    {String(timeLeft.seconds).padStart(2, "0")}
                                </p>
                            </div>

                        </div>

                        <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btn_from_to__cmIRG styles_active_fromDate_btn__8BHs6"
                            type="button"
                        >
                            <span className="MuiButton-label">
                                Từ &nbsp;<span>{formatDate(startTime || "")}</span>&nbsp; Đến &nbsp;<span>{formatDate(endTime)}</span>
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="mt-[8px]">
                <ProductsListBgColorNoneP0 products={products} />
                <div className="styles_seeAllContainer__9tVf0 MuiBox-root css-0">
                    {/* <a className="styles_seeAll___XmLX" href="/promotion/3q43g-clearance-near-expire--mien-nam?code=3Q43G">Xem tất cả</a>
                 */}
                </div>
            </div>
        </div>
    );
}
